
import request from "./request.js"
import { baseApiUrl } from "./config.js"

// method默认post
const api = {
	login: {
		url: "/api/technician.login/login"
	},
	orderList: {
		url: "/api/technician.order/orderList"
	},
	orderDetail: {
		url: "/api/technician.order/orderDetail"
	},
	orderStatus: {
		url: "/api/technician.order/orderChangeStatus" // 改变订单状态
	},
	orderRefuse: {
		url: "/api/technician.order/orderRefuse" // 无法服务
	},
	myInfo: {
		url: "/api/technician.personal/technicianInfo" // 我的页面资料
	},
	info: {
		url: "/api/technician.personal/technicianEdit" // 编辑技师信息
	},
	changeTime: {
		url: "/api/technician.work/workTimeEdit" // 修改工作和休息时间
	},
	workTime: {
		url: "/api/technician.work/workTimeList" // 工作和休息时间
	},
	feedback: {
		url: "/api/technician.personal/feedbackAdd" // 意见反馈
	},
	about: {
		url: "/api/technician.personal/fragmentInfo" // 关于我们和客服电话
	},
	uploadImg: {
		url: "/api/Osssave/upload"
	},
	GetCityDis:{
		url:"/api/pub/GetCityDis" // 获取一级城市
	},
	GetThreeCity:{
		url:"/api/pub/GetThreeCity" // 获取申请技师所有二级城市
	},
	withdraw: {
		url: "/api/technician.amount/withdraw" // 技师提现
	},
	balanceDetail: {
		url: "/api/technician.amount/balanceDetailList" // 资金明细列表
	},
	apply: {
		url: "/api/technician.login/register" // 申请成为技师
	},
	eva: {
		url: "/api/user.Comment/CommentList" // 查询评价
	},
	isOrder: {
		url: "/api/pub/isExistOrder" // 是否存在订单
	},
	warn: {
		url: "/api/pub/callPolice" // 一键报警
	},
	version: {
		url: "/api/pub/Version" // 版本更新
	},
	password: {
		url: "/api/technician.personal/editPass" // 修改密码
	},
	clockDown: {
		url: "/api/technician.order/clockDown" // 申请提前下钟
	},
	workNum: {
		url: "/api/technician.work/work_num" // 技师时间统计
	},
	workStatus: {
		url: "/api/technician.personal/WorkState", // 修改上班状态
	},
	tixianCount: {
		url: "/api/technician.amount/withdraw_count", // 提现可提现金额
	},
	leaveImage: {
		url: "/api/technician.order/leave_image", // 技师离开的照片
	},
	reply: {
		url: '/api/user.Comment/reply'
	},
	getGroupData: {
		url: '/api/technician.team_examine/data_count'
	},
	HistoricalJournal: {
		url: '/api/technician.team_examine/HistoricalJournal',
	},
	currentPeriod: {
		url: "/api/technician.team_examine/CurrentPeriod"
	},
	fetchMaterialList: {
		url: '/api/technician.material_goods/lists'
	},
	setPayment: {
		url: '/api/technician.material_order/add'
	},
	getMaterialOrders: {
		url:"/api/technician.material_order/order_lists"
	},
	fetchCustomerStatis: {
		url: '/api/technician.Visitor/data_statistics'
	},
	fetchCustomerList: {
		url: '/api/technician.Visitor/lists'
	},
	fetchGraphData: {
		url: '/api/technician.personal/area_data'
	},
	setOrderOver: {
		url: '/api/technician.order/service_end'
	},
	ponitsRule: {
		url: "/api/technician.team_examine/points_rule"
	},
	levelList: {
		url: "/api/technician.personal/level_list"
	},
	teamThisPeriod: { // 当前期团队业绩
		url: "/api/technician.team_examine/TeamCurrentPeriod"
	},
	teamHistoryPeriod: { // 技师团队历史业绩
		url: "/api/technician.team_examine/TeamHistoricalJournal"
	},
	comentTypeList: { // 技师团队历史业绩
		url: "/api/technician.comment_user/typeList"
	},
	customerCommentCount: {
		url: "/api/technician.comment_user/count"
	},
	customerComment: {
		url: "/api/technician.comment_user/add"
	},
	customerInfo: {
		url: "/api/technician.order/find_user_info"
	},
	noticeList: {
		url: "/api/technician.notice/lists"
	},
	noticeInfo: {
		url: "/api/technician.notice/info"
	},
	bindPhone: {
		url: "/api/technician.order/bind_phone"
	},
	withdrawHistory: {
		url: "/api/technician.amount/withdraw_log"
	},
	
	//所有地址
	addressList:{
		url:"/api/technician.Address/lists"
	},
	getAddressDetail: {
		url: "/api/technician.Address/info"
	},
	//添加或修改地址
	upAddress:{
		url:"/api/technician.Address/upAddress"
	},
	//删除地址
	delAdd:{
		url:"/api/technician.Address/del"
	},
	//设置默认地址
	setDefault:{
		url:"/api/technician.Address/setDefault"
	},
	// 获取默认地址
	getDefaultAddress: {
		url: "/api/technician.Address/DefaultInfo"
	},
	getLocationAddressDetail: {
		url: "/api/pub/AddressResolution"
	},
	// 申请更换城市
	updateMyCity: {
		url: "/api/technician.personal/change_city"
	},
	// 技师更换城市余额
	cityBalance: {
		url: "/api/technician.personal/city_balance"
	},
	// 是否存在十分钟之内结束的订单
	hasTenMinOrder: {
		url: "/api/technician.order/ten_min_order"
	},
	// 技师设置订单备注
	setOrderRemark: {
		url: "/api/technician.order/set_order_remark",
	},
	
	getAccount: {
		url: "/api/Technician.Personal/deputy_account"
	},
	putAccount: {
		url: "/api/technician.personal/hand_deputy_account"
	},
	contact:{
		url: "/api/technician.personal/contract_application"
	},
	
	month_money_list: { // 技师每月金额收益
		url: "/api/technician.amount/month_data_list", // 
	}
	
}
export const uploadImg = `${baseApiUrl}${api.uploadImg.url}` // 上传图片完整地址
// export const login = async (data) => {
// 	return request.get(api.login.url, data)
// }
// export const getUser = async (data) => {
// 	return request.get(api.getUser.url, data)
// }
const ApiGloabal = {}
for (const key in api) {
	const _obj = api[key]
	ApiGloabal[key] = async (data, config) => {
		try {
			if (String(_obj.method).toUpperCase() === 'GET') {
				return request.get(api[key].url, data,key)
			} else {
				return request.post(api[key].url, data,key)
			}
		} catch (error) {
			console.error(error)
		}
		
	}
}
export default ApiGloabal